{
    "production": false,
    "stg": false,
    "uat": false,
    "dev": false,
    "qat": false,
    "restApiUrl": "https://mobile-api{{placeholderEnvUrl}}",
    "cid": "{{placeholderCID}}",
    "bucketUrl" :"https://img{{placeholderUrl}}/{{placeholderCID}}",
    "cidfull": "{{placeholderCIDfull}}",
    "tradesSocketUrl": "wss://mobile-api{{placeholderEnvUrl}}:8443/connect/",
    "tradesTopics": "https://mobile-api{{placeholderEnvUrl}}:8443/topics",
    "storeUrlMT4Android": "https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4",
    "storeUrlCardAppiOS": "https://apps.apple.com/jo/app/windsor-brokers-card/id1505771662",
    "storeUrlCardAppAndroid": "https://play.google.com/store/apps/details?id=com.sedra.windsorbroker",
    "version": "5.2.7",
    "uriCardApp": "",
    "uriWEB": "NDTradingApp://",
    "uriMT4": "metatrader4://",
    "storeUrlWEBiOS": "",
    "storeUrlWEBAndroid": "https://play.google.com/store/apps/details?id=com.starfinancialsystems.swanmobile.intertraderdirect",
    "packageNameWEB": "com.starfinancialsystems.swanmobile.intertraderdirect",
    "mainTopic": "wbr_test_PricesTestHalfSec",
    "pushy_topics_suffix": "{{envSuffix}}",
    "tradingCentral": {
      "baseUrl":  "https://site.recognia.com/windsorbrokers/serve.shtml?tkn=",
      "baseUrl_dark": "https://site.recognia.com/windsorbrokers_dark/serve.shtml?tkn=",
      "key": "8+wMe5@hnjdcFR*SMC6_D-4%",
      "user": "testUser"
    },
    "cmsLink": "https://cms{{placeholderUrl}}/",
    "userHubLink": "{{placeholderUrl}}",
    "defaultLinkPrefix": "https://sc-{{env}}",
    "googleManagerId": "{{placeholderGoogleManagerId}}",
    "lrid": "{{placeholderLogRocketId}}",
    "lrf": "{{placeholderLogRocketFlag}}",
    "lrc": "{{placeholderLogRocketConfig}}",
    "fsf": "{{placeholderFullStoryFlag}}",
    "fsid": "{{placeholderFullStoryId}}",
    "googleManagerPath": "https://dt{{placeholderUrl}}/gtm.js",
    "marketingAPI": "https://marketing-api{{placeholderEnvUrl}}/pixel/?pt=",
    "restrictionIR": false,
    "secret_key": "{{placeholderSecretKey}}"
}